<div class="col leading-tight">
  @if (fiscalNumber) {
    <div class="flex items-baseline gap-2">
      <span class="text-[0.7rem] font-semibold uppercase tracking-wide text-surface-500">
        {{ 'ApDocument_Fiscal' | translateWF: 'Fiscal' }}
      </span>
      <span class="font-medium">{{ fiscalNumber }}</span>
    </div>
  }

  <div class="row-sm-start-center flex-wrap">
    @if (clickable) {
      <a class="cursor-pointer text-primary hover:underline" [class.text-sm]="!isPrimary" [class.font-medium]="isPrimary" [title]="linkTitle ?? ''" (click)="onDocumentClick()">{{
        documentNumber || '—'
      }}</a>
    } @else {
      <span [class.text-sm]="!isPrimary" [class.text-surface-500]="!isPrimary" [class.font-medium]="isPrimary">{{ documentNumber || '—' }}</span>
    }
    <!-- Row badges (credit, settled, adjustments…) — the caller's, not ours. -->
    <ng-content />
  </div>
</div>
